import { useEffect } from 'react';
import { isLowPowerEnvironment } from '@/utils/performance';

export function useSmoothScroll(disable = false) {
  useEffect(() => {
    if (disable || isLowPowerEnvironment()) {
      return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) {
      return;
    }

    let lenis: any = null;
    let rafId = 0;

    const init = async () => {
      const { default: Lenis } = await import('lenis');

      lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 2,
        infinite: false,
      });

      const raf = (time: number) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };

      rafId = requestAnimationFrame(raf);
    };

    init();

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible' && lenis && !rafId) {
        // Simple way to restart if needed, though raf usually handles it
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (lenis) {
        lenis.destroy();
      }
    };
  }, [disable]);
}
